var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('img',{staticClass:"admineArriveLogo",style:(_vm.getStyle()),attrs:{"src":this.logo,"alt":"Logo"}}),_c('div',{staticClass:"adminArriveText"},[_vm._v(" "+_vm._s(_vm.name)+" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }